import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useFacility } from "@/context/FacilityContext";
import { PageHeader } from "@/components/common/PageHeader";
import { UsersManager } from "@/components/common/UsersManager";

export default function TenantUsers() {
  const { auth } = useAuth();
  const { has } = useFacility();
  return (
    <div data-testid="tenant-users-page">
      <PageHeader title="Users" subtitle="Staff accounts in your organisation, with facility assignments and roles." />
      <UsersManager orgId={auth?.organisation?.id} canEdit={has("user:create")} testId="tenant-users-manager" />
    </div>
  );
}
